export default "__VITE_ASSET__e2Y5Cyhi__"